/* Moss & Molt phone/desktop nav fixes (moved out of snippets/mm-oct15-nav.liquid, audit #13, Oct 29 2026, so browsers cache it). Loaded with defer. */
(function () {
  if (window.__mmOct15Nav) return; window.__mmOct15Nav = true;

  /* 12. Oct 19 2026, 12:19 a.m. (David added Instagram and Facebook to the More menu): menu links to other sites (Instagram, Facebook)
     open in a new tab, so the shopper keeps their place on Moss & Molt. Delegated, so it survives Horizon re-rendering the header. */
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!a.closest("header, #header-component, header-drawer, .menu-drawer")) return;
    var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
    if (!/^https?:$/.test(u.protocol) || u.host === location.host || /(^|\.)(myshopify|shopify)\.com$/.test(u.hostname)) return;
    e.preventDefault(); window.open(u.href, "_blank", "noopener");
  }, true);

  /* 3. phones: search button at the top right of the slide-out menu */
  function openSearch() {
    var orig = document.querySelector("#header-component .search-action button");
    if (orig) { orig.click(); return; }
    var modal = document.getElementById("search-modal");
    if (modal && typeof modal.showDialog === "function") modal.showDialog();
  }
  function addDrawerSearch(panel) {
    if (panel.querySelector(":scope > .mm-dsearch")) return;
    var b = document.createElement("button");
    b.type = "button"; b.className = "mm-dsearch"; b.setAttribute("aria-label", "Search");
    b.addEventListener("click", function (e) {
      e.preventDefault();
      var close = panel.querySelector(".menu-drawer__close-button");
      if (close) close.click();
      setTimeout(openSearch, 60);
    });
    panel.appendChild(b);
  }

  /* 4. phones: SHOP opens and closes its category list.
     v1.1 (Oct 15 ~10:00 p.m.): Horizon re-renders ("hydrates") the header right after the page loads. It keeps the
     same SHOP link but wipes the classes this code added, so v1.0 attached a second tap handler and every tap
     opened and instantly closed the list (David: "not doing anything when tapped"). Now one tap handler lives on
     the page itself and the link only gets its look (class, caret, aria) re-applied, which is safe to repeat. */
  function shopToggle(panel) {
    panel.querySelectorAll("li > a.menu-drawer__menu-item--mainlist").forEach(function (a) {
      var li = a.parentNode, list = li.querySelector(":scope > .menu-drawer__menu--childlist");
      if (!list) return;
      a.classList.add("mm-shop-toggle");
      a.setAttribute("role", "button");
      a.setAttribute("aria-expanded", li.classList.contains("mm-shop-open") ? "true" : "false");
      if (!list.id) list.id = "mm-drawer-sub-" + Math.random().toString(36).slice(2, 8);
      a.setAttribute("aria-controls", list.id);
      if (!a.querySelector(":scope > .mm-caret")) {
        var c = document.createElement("span"); c.className = "mm-caret"; c.setAttribute("aria-hidden", "true");
        a.appendChild(c);
      }
    });
  }
  function ddClose(li) {
    li.classList.remove("mm-shop-open");
    var t = li.querySelector(":scope > a.mm-shop-toggle"); if (t) t.setAttribute("aria-expanded", "false");
  }
  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    var x = t ? t.closest("#header-component .menu-drawer .mm-pop-x") : null;
    if (x) { e.preventDefault(); var pl = x.closest("li.mm-shop-open"); if (pl) { ddClose(pl); var pa = pl.querySelector(":scope > a.mm-shop-toggle"); if (pa) pa.focus(); } return; }
    var inPop = t ? t.closest("#header-component .menu-drawer li.mm-shop-open") : null;
    if (inPop) setTimeout(function () { if (inPop.classList.contains("mm-shop-open")) ddPlace(inPop); }, 0);   // Mode / Language fly-outs open inside More
    // 13. a tap anywhere outside the open dropdown (and its own word) closes it
    document.querySelectorAll("#header-component .menu-drawer li.mm-shop-open").forEach(function (o) { if (!t || !o.contains(t)) ddClose(o); });
    var a = t ? t.closest("#header-component .menu-drawer li > a.mm-shop-toggle") : null;
    if (!a) return;
    var li = a.parentNode;
    if (!li.querySelector(":scope > .menu-drawer__menu--childlist")) return;
    e.preventDefault();
    var open = !li.classList.contains("mm-shop-open");
    li.classList.toggle("mm-shop-open", open);
    a.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) ddPlace(li);
  });

  /* 13. phones: the menu doesn't scroll when its main list fits. Oct 27 2026: an open dropdown is a popup at a FIXED spot (POP_TOP
     under the menu's top, 8 px in from its sides); rows shrink together until they fit above the menu's bottom (not below 60%); only
     past that does it scroll. ~~Under its word / above it / wherever it fits~~ dead. */
  var POP_TOP = 52, POP_MIN = .6;
  function ddHead(li) {
    var list = li.querySelector(":scope > .menu-drawer__menu--childlist"), a = li.querySelector(":scope > a.mm-shop-toggle");
    if (!list || !a || list.querySelector(":scope > .mm-pop-head")) return;
    var h = document.createElement("li"); h.className = "mm-pop-head"; h.setAttribute("role", "presentation");
    var t = document.createElement("span"); t.textContent = (a.textContent || "").trim();
    var x = document.createElement("button"); x.type = "button"; x.className = "mm-pop-x"; x.setAttribute("aria-label", "Close " + t.textContent); x.textContent = "\u00d7";
    h.appendChild(t); h.appendChild(x); list.insertBefore(h, list.firstChild);
  }
  function ddPlace(li) {
    var list = li.querySelector(":scope > .menu-drawer__menu--childlist"), dr = li.closest(".menu-drawer");
    if (!list || !dr) return;
    ddHead(li);
    ["--mm-dd-max", "--mm-pop-z"].forEach(function (k) { list.style.removeProperty(k); });
    var L = li.getBoundingClientRect(), D = dr.getBoundingClientRect();
    var top = D.top + POP_TOP, avail = D.bottom - 8 - top;
    list.style.setProperty("--mm-dd-top", (top - L.top) + "px");
    list.style.setProperty("--mm-dd-left", (D.left + 8 - L.left) + "px");
    list.style.setProperty("--mm-dd-w", (D.width - 16) + "px");
    var z = 1;
    for (var n = 0; n < 4 && list.offsetHeight > avail + 1 && z > POP_MIN; n++) {   // padding doesn't shrink, so a few passes
      z = Math.max(POP_MIN, z * avail / list.offsetHeight); list.style.setProperty("--mm-pop-z", z.toFixed(3));
    }
    if (list.offsetHeight > avail + 1) list.style.setProperty("--mm-dd-max", Math.max(80, avail) + "px");
  }
  function ddFit() {
    var dr = document.querySelector("#header-component header-drawer .menu-drawer");
    if (!dr || !dr.offsetHeight) return;
    dr.classList.remove("mm-dfixed");
    if (dr.scrollHeight <= dr.clientHeight + 1) { dr.scrollTop = 0; dr.classList.add("mm-dfixed"); }
    dr.querySelectorAll("li.mm-shop-open").forEach(ddPlace);
  }
  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches("header-drawer details")) return;
    if (d.open) { setTimeout(ddFit, 50); setTimeout(ddFit, 450); }   // again after the slide-in animation
    else d.querySelectorAll(".menu-drawer li.mm-shop-open").forEach(ddClose);
  }, true);
  window.addEventListener("resize", function () { clearTimeout(ddFit.t); ddFit.t = setTimeout(ddFit, 150); });
  // Oct 27 2026: a menu that still scrolls (phone on its side) keeps an open popup in its spot; Escape closes it
  document.addEventListener("scroll", function (e) { var d = e.target; if (d && d.matches && d.matches("#header-component .menu-drawer")) d.querySelectorAll("li.mm-shop-open").forEach(ddPlace); }, true);
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    document.querySelectorAll("#header-component .menu-drawer li.mm-shop-open").forEach(function (o) { ddClose(o); var a = o.querySelector(":scope > a.mm-shop-toggle"); if (a) a.focus(); });
  });

  /* 7. footer: Shipping & Weather button above "Join our email list" */
  function moveShipButton() {
    var cta = document.querySelector("footer .mm-foot__cta");
    // GitHub #16 (Oct 17 2026): found by its email sign-up form, not by the section's generated id, so duplicating or reordering
    // footer sections in the editor doesn't break it (the old id still works as a fallback)
    var sign = document.querySelector('footer .email-signup-block'), mail = (sign && sign.closest('.shopify-section')) || document.querySelector('footer .shopify-section[id$="__footer_m9NzUG"]');
    if (!cta || !mail || cta.closest(".mm-ship-slot")) return;
    var slot = document.createElement("div");
    slot.className = "mm-ship-slot";
    slot.appendChild(cta);
    mail.parentNode.insertBefore(slot, mail);
  }

  /* 10. computers: menu words that don't fit on one line fold into a ". . ." dropdown */
  var DESK = window.matchMedia("(min-width: 750px)");
  function moreLi(ol) {
    var li = ol.querySelector(":scope > li.mm-more");
    if (li) return li;
    li = document.createElement("li");
    li.className = "menu-list__list-item mm-more mm-more--off";
    li.innerHTML = '<button type="button" class="menu-list__link button-unstyled mm-more__btn" aria-haspopup="true" aria-expanded="false" aria-label="More pages">' +
      '<span class="menu-list__link-title">. . .</span></button><div class="mm-more__list"><ul></ul></div>';
    var t = 0;
    var open = function (on) { clearTimeout(t); li.classList.toggle("mm-open", on); li.firstChild.setAttribute("aria-expanded", on ? "true" : "false"); };
    li.addEventListener("pointerenter", function (e) { if (e.pointerType !== "touch") open(true); });
    li.addEventListener("pointerleave", function (e) { if (e.pointerType !== "touch") { clearTimeout(t); t = setTimeout(function () { open(false); }, 180); } });
    li.firstChild.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); open(!li.classList.contains("mm-open")); });
    li.addEventListener("focusout", function (e) { if (!li.contains(e.relatedTarget)) open(false); });
    li.addEventListener("keydown", function (e) { if (e.key === "Escape" && li.classList.contains("mm-open")) { open(false); li.firstChild.focus(); } });
    document.addEventListener("click", function (e) { if (!li.contains(e.target)) open(false); });
    li.__open = open;
    ol.appendChild(li);
    return li;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  var fitting = false;
  function fitMenu() {
    var hc = document.getElementById("header-component"), ol = hc && hc.querySelector("header-menu overflow-list");
    if (!ol || fitting) return;
    fitting = true;
    try {
      var more = moreLi(ol);
      var items = Array.prototype.filter.call(ol.children, function (li) { return li.matches("li.menu-list__list-item:not([slot]):not(.mm-more)"); });
      items.forEach(function (li) { li.classList.remove("mm-ovf"); });
      more.classList.add("mm-more--off");
      var hidden = [];
      if (DESK.matches && hc.getAttribute("data-menu-style") === "menu" && items.length > 1) {
        var first = items[0].getBoundingClientRect(), line = first.bottom;
        var wrapped = function (el) { var r = el.getBoundingClientRect(); return r.height && (r.top + r.bottom) / 2 > line; };
        var wraps = function () { return items.some(function (li) { return !li.classList.contains("mm-ovf") && wrapped(li); }) || (!more.classList.contains("mm-more--off") && wrapped(more)); };
        if (wraps()) {
          more.classList.remove("mm-more--off");
          for (var i = items.length - 1; i >= 1 && wraps(); i--) items[i].classList.add("mm-ovf");
          hidden = items.filter(function (li) { return li.classList.contains("mm-ovf"); });
        }
      }
      var html = hidden.map(function (li) {
        var a = li.querySelector("a.menu-list__link"); if (!a) return "";
        var out = '<li><a href="' + esc(a.getAttribute("href")) + '">' + esc(a.textContent.trim()) + "</a></li>";
        li.querySelectorAll(".menu-list__submenu a.mega-menu__link").forEach(function (s) {
          out += '<li><a class="mm-sub" href="' + esc(s.getAttribute("href")) + '">' + esc(s.textContent.trim()) + "</a></li>";
        });
        return out;
      }).join("");
      var ul = more.querySelector("ul");
      if (ul.__html !== html) { ul.innerHTML = html; ul.__html = html; }
      if (!hidden.length && more.__open) more.__open(false);
    } finally { fitting = false; }
  }
  var fitRaf = 0;
  function fitSoon() { if (!fitRaf) fitRaf = requestAnimationFrame(function () { fitRaf = 0; fitMenu(); }); }
  var fitRO = null;
  function watchMenu() {
    var ol = document.querySelector("#header-component header-menu overflow-list");
    if (!ol || ol.__mmFitWatched || !("ResizeObserver" in window)) return;
    ol.__mmFitWatched = true;
    if (!fitRO) fitRO = new ResizeObserver(fitSoon);
    fitRO.observe(ol); fitRO.observe(document.getElementById("header-component"));
  }
  window.addEventListener("resize", fitSoon);
  if (DESK.addEventListener) DESK.addEventListener("change", fitSoon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSoon);

  /* 12. CARE GUIDE and TANK SIMULATOR shine (word wrapped once; re-wrapped if Horizon redraws the header) */
  var SHIM = /\/pages\/(aquarium-doctor|tank-builder|aquarium-sim)(?:[?#\/]|$)/; // Oct 30 2026: Sim link moved to /pages/aquarium-sim (P&C fix)
  function shimHere(a) {
    try { var u = new URL(a.getAttribute("href"), location.href); return u.pathname.replace(/\/$/, "") === location.pathname.replace(/\/$/, ""); }
    catch (e) { return false; }
  }
  function shimLink(a) {
    if (a.querySelector(".mm-shim") || shimHere(a)) return;
    var w = document.createTreeWalker(a, NodeFilter.SHOW_TEXT, null), tn = null, n;
    while ((n = w.nextNode())) { if (n.nodeValue.trim()) { tn = n; break; } }
    if (!tn) return;
    var raw = tn.nodeValue, label = raw.trim(), lead = raw.slice(0, raw.indexOf(label)), tail = raw.slice(raw.indexOf(label) + label.length);
    if (!a.hasAttribute("aria-label")) a.setAttribute("aria-label", label);
    var box = document.createElement("span");
    box.className = "mm-shim";
    box.style.setProperty("--mm-shim-d", /tank-builder|aquarium-sim/.test(a.getAttribute("href")) ? ".6s" : "0s");
    box.textContent = label;
    box.setAttribute("data-label", label);
    var frag = document.createDocumentFragment();
    if (lead) frag.appendChild(document.createTextNode(lead));
    frag.appendChild(box);
    if (tail) frag.appendChild(document.createTextNode(tail));
    tn.parentNode.replaceChild(frag, tn);
  }
  function shimAll() {
    var hc = document.getElementById("header-component");
    if (!hc) return;
    // Oct 23 2026: Care Guide now sits inside the EDUCATION dropdown; only top-level menu links shine, not the dropdown's rows
    hc.querySelectorAll("a[href]").forEach(function (a) { if (SHIM.test(a.getAttribute("href")) && !a.closest(".menu-list__submenu, .menu-drawer__menu--childlist, .menu-drawer__menu--grandchildlist, .mm-acct")) shimLink(a); });
  }
  var shimRaf = 0;
  function shimSoon() { if (!shimRaf) shimRaf = requestAnimationFrame(function () { shimRaf = 0; shimAll(); }); }
  function shimStart() {
    shimAll();
    var hc = document.getElementById("header-component");
    if (hc && !hc.__mmShimWatched && window.MutationObserver) {
      hc.__mmShimWatched = true;
      new MutationObserver(shimSoon).observe(hc, { childList: true, subtree: true });
    }
  }
  shimStart();
  document.addEventListener("DOMContentLoaded", shimStart);

  /* 11. phones: home reviews as a swipeable row of half-width boxes (copies of Judge.me's finished cards) */
  var PHONE = window.matchMedia("(max-width: 749px)"), rvBusy = false;
  function rvRoots() {
    // Oct 18 2026 (GitHub #50): the home section holding the app block (was the generated id __17907930702ecb4d62, dead)
    var ab = document.querySelector('main[data-template="index"] .shopify-section .shopify-app-block');
    var sec = ab && ab.closest(".shopify-section"); if (!sec) return null;
    var roots = [sec];
    sec.querySelectorAll("*").forEach(function (el) { if (el.shadowRoot) roots.push(el.shadowRoot); });
    return { sec: sec, roots: roots };
  }
  function rvBuild() {
    if (rvBusy) return; rvBusy = true;
    try {
      var r = rvRoots(); if (!r) return;
      var old = r.sec.querySelector(".mm-rv"), hidden = r.sec.querySelector(".mm-rv-hide"), hint = r.sec.querySelector(".mm-rv-hint");
      var items = [];
      r.roots.forEach(function (root) { root.querySelectorAll(".jm-review-item").forEach(function (el) { if (!el.closest(".mm-rv")) items.push(el); }); });
      if (!PHONE.matches || items.length < 2 || items[0].getRootNode() !== document) {
        if (old) old.remove(); if (hint) hint.remove(); if (hidden) hidden.classList.remove("mm-rv-hide"); return;
      }
      // Judge.me loops its slider with duplicate cards; keep each review once
      var seen = {}, uniq = items.filter(function (el) { var k = el.textContent.replace(/\s+/g, " ").trim(); if (seen[k]) return false; seen[k] = 1; return true; });
      var keyOf = function (el) { return el.textContent.replace(/\s+/g, " ").trim(); };
      if (old && old.__keys && uniq.every(function (el) { return old.__keys[keyOf(el)]; })) return; // nothing new
      // the slider block: the outermost box around all the cards that doesn't also hold the heading
      var track = items[0].parentElement;
      while (track && !items.every(function (el) { return track.contains(el); })) track = track.parentElement;
      var block = track, top = r.sec.querySelector(".jdgm-cards-carousel") || r.sec.querySelector(".shopify-app-block");
      while (block && block.parentElement && block.parentElement !== top && top && top.contains(block.parentElement) && !Array.prototype.some.call(block.parentElement.querySelectorAll("h1, h2, h3"), function (h) { return !h.closest(".jm-review-item"); })) block = block.parentElement;
      if (!block) return;
      var row = old || document.createElement("div");
      row.className = "mm-rv"; row.setAttribute("role", "region"); row.setAttribute("aria-label", "Customer reviews, swipe for more"); row.tabIndex = 0;
      row.__keys = row.__keys || {};
      uniq.forEach(function (el) {
        var k = keyOf(el); if (row.__keys[k]) return; row.__keys[k] = 1; // only add reviews not already in the row (keeps the swipe position)
        var cell = document.createElement("div"); cell.className = "mm-rv__item";
        var c = el.cloneNode(true);
        c.querySelectorAll("[id]").forEach(function (x) { x.removeAttribute("id"); });
        c.querySelectorAll("img[data-src]").forEach(function (x) { if (!x.getAttribute("src")) x.setAttribute("src", x.getAttribute("data-src")); });
        c.removeAttribute("aria-hidden"); c.removeAttribute("inert");
        cell.appendChild(c); row.appendChild(cell);
      });
      if (!old) block.insertAdjacentElement("afterend", row);
      if (!hint) { hint = document.createElement("p"); hint.className = "mm-rv-hint"; hint.textContent = "Swipe for more reviews \u203a"; row.insertAdjacentElement("afterend", hint); }
      if (hidden && hidden !== block) hidden.classList.remove("mm-rv-hide");
      block.classList.add("mm-rv-hide");
    } finally { rvBusy = false; }
  }
  var rvT = 0;
  function rvSoon() { clearTimeout(rvT); rvT = setTimeout(rvBuild, 250); }
  function rvWatch() {
    var r = rvRoots(); if (!r || r.sec.__mmRv) return; r.sec.__mmRv = true;
    new MutationObserver(function (muts) {
      if (muts.every(function (m) { return m.target.closest && (m.target.closest(".mm-rv") || m.target.classList.contains("mm-rv")); })) return;
      rvSoon();
    }).observe(r.sec, { childList: true, subtree: true });
    if (PHONE.addEventListener) PHONE.addEventListener("change", rvSoon);
    rvSoon();
  }

  function header() {
    watchMenu(); fitSoon(); rvWatch();
    var panel = document.querySelector("#header-component .menu-drawer");
    if (!panel) return;
    addDrawerSearch(panel); shopToggle(panel);
  }
  function go() {
    header(); moveShipButton();
    var hdr = document.getElementById("header-component");
    if (hdr && window.MutationObserver) new MutationObserver(header).observe(hdr, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", go); else go();
})();
